// 261023 E3-P3h5a lượt 2 (F1/F2/F3/F6) — lọc SỐ TIỀN khỏi chữ ĐỘNG do BE gửi (note cổng, lỗi API, lý do, modal kỹ thuật). THUẦN.
// Luật: lọc theo SỐ TIỀN, không lọc theo TỪ. Chỉ nhận diện `$` kèm số (kể cả «/truyện» đi theo), số kèm USD / xu, và chữ USD đứng riêng.
// Chỗ khớp thay bằng cụm không số. KHÔNG đụng «trần», «Trần Minh», «xu hướng», «ngân sách», «chi phí» khi không có số tiền đi kèm.
const REPLACEMENT = 'mức giới hạn';

const NUM = String.raw`\d+(?:[.,]\d+)*`;   // không nuốt dấu «.» / «,» cuối câu: «$5.» ⇒ «…giới hạn.»
/**
 * `$5`, `$ 0.31`, `$1,234.50`, `$5/truyện`, `$5 USD` | `5 USD`, `1–6 xu`, `12 xu` (chữ «xu» THƯỜNG; «Xu» viết hoa là tên riêng, không phải «12 xu hướng») | chữ `USD` đứng riêng.
 * Không cờ `i`: «Tập 5 Xu Ming» (tên riêng) giữ nguyên. Cờ `g` chỉ để `.replace`; muốn kiểm có/không dùng `hasMoneyAmount`.
 */
export const MONEY_AMOUNT_RE = new RegExp(
  [
    String.raw`\$\s?${NUM}(?:\s?\/\s?\p{L}+)?(?:\s?(?:USD|usd)(?![\p{L}]))?`,
    String.raw`${NUM}(?:\s?[–-]\s?${NUM})?\s?(?:USD|usd|xu)(?![\p{L}])(?!\s+hướng)`,
    String.raw`(?<![\p{L}\d])(?:USD|usd)(?![\p{L}])`,
  ].join('|'),
  'gu',
);

export const redactMoney = (text: string | null | undefined): string => {
  const s = (text ?? '').toString();
  if (!s) return '';
  return s.replace(MONEY_AMOUNT_RE, REPLACEMENT);
};

/** Có số tiền trong chuỗi không (an toàn với cờ `g`: không giữ `lastIndex`). */
export const hasMoneyAmount = (text: string | null | undefined): boolean => new RegExp(MONEY_AMOUNT_RE.source, 'u').test((text ?? '').toString());
